module.exports = __webpack_public_path__ + "static/media/surfing.3d2a2cbd.jpeg";